"use strict";
var Observable_1 = require('../../Observable');
var retryWhen_1 = require('../../operator/retryWhen');
Observable_1.Observable.prototype.retryWhen = retryWhen_1.retryWhen;
//# sourceMappingURL=retryWhen.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/retryWhen.js
// module id = 1080
// module chunks = 0